import { render, staticRenderFns } from "./OpenapiList.vue?vue&type=template&id=21a2f873&scoped=true&"
import script from "./OpenapiList.vue?vue&type=script&lang=js&"
export * from "./OpenapiList.vue?vue&type=script&lang=js&"
import style0 from "./OpenapiList.vue?vue&type=style&index=0&id=21a2f873&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a2f873",
  null
  
)

export default component.exports